export const INSERT_EMOJI_COMMAND = 'insertEmoji';
